import React, { useContext } from 'react';
import { ApplicationContext } from '../contexts/ApplicationContext';

export function useApplicationContext() {
    return useContext(ApplicationContext);
}
